require('./openYoungCardBudgetsView.scss');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const moment = require('moment');

// @commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { TabbedContentBox } = require('commonsComponents/tabbedContentBox');

// @components
const CardMoreOptionsButton = require('components/cards/cardMoreOptionsButton/cardMoreOptionsButton');
const CardManageOptionsButton = require('components/cards/cardManageOptionsButton/cardManageOptionsButton');
const OpenYoungCardExpenses = require('./components/openYoungCardExpenses');
const OpenYoungCardBudget = require('./components/openYoungCardBudget');

// @ utilities
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { toFirstUppercase } = require('utilities/stringHelper');

// @actions
const openYoungCardExpensesActions = require('actions/openYoungCardExpenses');
//@actions
const openYoungCardBudgetsAction = require('actions/openYoungCardBudgets');

// @constants
const { DATE_FORMAT_API } = require('constants/index');

class OpenYoungCardBudgetsView extends React.Component {
    constructor(props) {
        super(props);
        this.getExpenseDetails = this.getExpenseDetails.bind(this);
    }

    componentDidMount() {
        const { match: { params: { cardId } }, immCards, getBudgetList, setComparativeMonth } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const firstDayOfCurrentMonth = moment().format(DATE_FORMAT_API);
        this.getExpenseDetails();
        getBudgetList(immCard, firstDayOfCurrentMonth);
        setComparativeMonth(firstDayOfCurrentMonth);
    }

    componentWillUnmount() {
        this.props.clearExpenseFilter();
    }

    getExpenseDetails() {
        const { match: { params: { cardId } }, immCards, getExpenseList } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        getExpenseList(immCard);
    }

    render() {
        const {
            match: { params: { cardId } },
            immCards,
            flagBasedFeatures,
            openYoungCardExpenses,
            setExpenseFilter,
            openYoungBudget,
            getBudgetList,
            setComparativeMonth
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const childName = immCard.get('beneficiaryNameOnCard').replace(/\*/g, ' ');
        const formattedChildName = childName && childName.split(" ").map(str => toFirstUppercase(str)).join(" ");
        let content;
        if (immCards.get('isFetching')) {
            content = <LoadingSection />;
        } else if (immCard) {
            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = immCard.getIn(['alias','current']);
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.getIn(['alias', 'current']),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText('breadcrumb-expenseAndBudget')
                }
            ];
            const optionsVisible = {
                budgets: false,
                chores: true
            };
            const manageOptionsButton = (
                <CardManageOptionsButton
                    flagBasedFeatures={flagBasedFeatures}
                    immCard={immCard}
                    cardId={cardId}
                    optionsVisible={optionsVisible}
                />
            );
            const showManageOptionsBtn = flagBasedFeatures.get('budget') || flagBasedFeatures.get('chores');
            const openYoungCardExpensesComponent = (
                <OpenYoungCardExpenses
                    cardId={cardId}
                    immCards={immCards}
                    openYoungCardExpenses={openYoungCardExpenses}
                    getExpenseDetails={this.getExpenseDetails}
                    setExpenseFilter={setExpenseFilter}
                />
            );
            const openYoungCardBudget = (
                <OpenYoungCardBudget
                    cardId={cardId}
                    immCard={immCard}
                    getBudgetList={getBudgetList}
                    immBudgetExpense={openYoungBudget}
                    selectedMonth={openYoungBudget.get('selectedMonth')}
                    setComparativeMonth={setComparativeMonth}
                />
            );

            content = (
                <div className="open-young-budgets">
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    finalTitle={getFinalTitle('openYoungBudgets-headerTitle')}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                >
                                    <CardMoreOptionsButton flagBasedFeatures={flagBasedFeatures} immCard={immCard} cardId={cardId} />
                                    {showManageOptionsBtn && manageOptionsButton}
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                <div className="col-xs-12 col-md-12 col-lg-12">
                                    <div className="open-young-budgets__content">
                                        <header>
                                            <div className="open-young-budgets__title">
                                                <OKBoxTitle value={formatText('openYoungBudgets-listTitle')} />
                                            </div>
                                        </header>
                                        <p className="open-young-budgets__sub-title">
                                            <FormattedText value="openYoungBudgets-listSubTitle" injectedStrings={[formattedChildName]}/>
                                        </p>
                                        <TabbedContentBox
                                            id="openYoungExpenseAndBudget"
                                            tabComponents={[openYoungCardExpensesComponent, openYoungCardBudget]}
                                            title=""
                                            tabLabels={[formatText('openYoungBudgets-expensesTabName'), formatText('openYoungBudgets-budgetsTabName')]}
                                            defaultTabIndex={0}
                                            tabsAsPills={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return content;
    }
}
OpenYoungCardBudgetsView.propTypes = {
    clearExpenseFilter: PropTypes.func,
    flagBasedFeatures: PropTypes.object.isRequired,
    getBudgetList: PropTypes.func.isRequired,
    getExpenseList: PropTypes.func,
    immCards: PropTypes.object.isRequired,
    openYoungBudget: PropTypes.object.isRequired,
    openYoungCardExpenses:PropTypes.object,
    match: PropTypes.object.isRequired,
    setComparativeMonth: PropTypes.func,
    setExpenseFilter: PropTypes.func
};

module.exports.constructor = OpenYoungCardBudgetsView;
module.exports.OpenYoungCardBudgetsView = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        immCards: state.cards,
        openYoungBudget: state.openYoungBudget,
        openYoungCardExpenses: state.openYoungCardExpenses
    }), {
        clearExpenseFilter: openYoungCardExpensesActions.clearOpenYoungCardExpenseFilter,
        getBudgetList: openYoungCardBudgetsAction.getBudgetList,
        getExpenseList: openYoungCardExpensesActions.getExpenseList,
        setComparativeMonth: openYoungCardBudgetsAction.setComparativeMonth,
        setExpenseFilter: openYoungCardExpensesActions.setOpenYoungCardExpenseFilter
    })(OpenYoungCardBudgetsView);
